import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm';
import { useParams } from 'react-router-dom';
import { convertToFormData, sweetAlert } from '../../../utils';
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService';
import { responseError } from '../../../helpers/responseHandler';

const StepOne = ({ activeStep, setActiveStep, params, isEdit }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()
    const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()


    const onSubmit = async (data) => {
        const newForm = convertToFormData({ step_no: '8', ...data })
        await editRequest({ params, newForm }).unwrap()
            .then((res) => {
                setActiveStep(7)
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                }
                // if (res?.errors) {
                //     Object.entries(res?.errors)?.forEach(([key, value]) => {
                //         sweetAlert(value[0], 'error')
                //     })
                // }
            })
            .catch((err) => {
                responseError(err)
            })
    }


    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Consent and Legal Agreements</h5>

                            <div className="row">
                                <Form onSubmit={handleSubmit(onSubmit)} className="col-md-12" id='application-status'>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='ConsentBackground'>Consent for Background Check:</Form.Label>
                                                <Controller
                                                    name='consent_bc'
                                                    control={control}
                                                    defaultValue={Boolean(isEdit?.consent_bc) ? 1 : 0}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Check
                                                            type="checkbox"
                                                            defaultChecked={field.value}
                                                            id="ConsentBackground"
                                                            label="I give consent for background check"
                                                            onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                            isInvalid={errors.consent_bc}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='ConsentDrug'>Consent for Drug Testing:</Form.Label>
                                                <Controller
                                                    name='consent_drug_testing'
                                                    control={control}
                                                    defaultValue={Boolean(isEdit?.consent_drug_testing) ? 1 : 0}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Check
                                                            type="checkbox"
                                                            defaultChecked={field.value}
                                                            id="ConsentDrug"
                                                            label="I give consent for drug testing"
                                                            onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                            isInvalid={errors.consent_drug_testing}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='ConsentSocial'>Consent for Social Security Verification:</Form.Label>
                                                <Controller
                                                    name='consent_ssv'
                                                    control={control}
                                                    defaultValue={Boolean(isEdit?.consent_ssv) ? 1 : 0}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Check
                                                            type="checkbox"
                                                            defaultChecked={field.value}
                                                            id="ConsentSocial"
                                                            label="I give consent for social security verification"
                                                            onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                            isInvalid={errors.consent_ssv}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='ConsentVR'>Consent to MVR Check:</Form.Label>
                                                <Controller
                                                    name='consent_mvr_check'
                                                    control={control}
                                                    defaultValue={Boolean(isEdit?.consent_mvr_check) ? 1 : 0}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Check
                                                            type="checkbox"
                                                            defaultChecked={field.value}
                                                            id="ConsentVR"
                                                            label="I give consent to MVR check"
                                                            onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                            isInvalid={errors.consent_mvr_check}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>

                                    </div>
                                </Form>

                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(5)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                {/* <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(7)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                                <div className="col-lg-3 d-flex mb-3">
                                    <LoadingButtonWithForm
                                        isLoading={editLoading}
                                        name="Next & Save"
                                        form="application-status"
                                        className="text-white mt-auto w-100"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default StepOne;